import { useEffect } from "react";
import { Navigate, useParams } from "react-router-dom";
import { storeReferralCode } from "@/lib/referrals";
import { track } from "@/lib/posthog";

/** /r/:code — remember the code, then send the visitor to sign-up. */
const ReferralLanding = () => {
  const { code = "" } = useParams();
  const valid = /^[A-Za-z0-9]{6,12}$/.test(code);
  useEffect(() => {
    if (!valid) return;
    storeReferralCode(code);
    track("referral_landing_viewed", { code: code.toUpperCase() });
  }, [code, valid]);
  return <Navigate to="/" replace />;
};

export default ReferralLanding;
